/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Flowminsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Minimum flow setpoint" |
*
* @param {Ahu_History_Key_Flowminsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_flowminsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Flowminsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Flowminsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum flow setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum de débit")
});
export { ahu_history_key_flowminsetpoint2 as "ahu_history_key_flowMinSetpoint" }